import {  CallReturn, DeleteDocumentResult, DocumentResult, ETenderPublishOptions, ETenderPublishService, TenderResult } from "@nt-portal/tcm-sdk";
import { BaseClientService } from "../../base-client.service";

export class ClientETenderPublishService extends BaseClientService {
private _service: ETenderPublishService;


    constructor() {
        super();
        this._service = new ETenderPublishService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async publishETender(options: ETenderPublishOptions): Promise<CallReturn<TenderResult | DocumentResult | DeleteDocumentResult>[]> {

        return await this._service.publishETender(this.token, options);
    }

}